<template lang="pug">
    .helper(:class='{black: isBlack, show: reachEndTriggerOnce}')
        .helper__arrow
            svg(xmlns='http://www.w3.org/2000/svg', viewBox='0 0 306 306', width='306', height='306')
                path(d='M94.35 0l-35.7 35.7L175.95 153 58.65 270.3l35.7 35.7 153-153z')
        .helper__text {{urltext}}
</template>

<script>
export default {
    name: 'NextPageHelper',

    props: {
        urltext: {
            default: '',
            type: String
        },
        trigger: {
            default: false,
            type: Boolean
        },
        isBlack: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            reachEndTriggerOnce: false
        };
    },

    watch: {
        trigger(newVal) {
            if (this.reachEndTriggerOnce && newVal) {
                setTimeout(() => {
                    this.$router.push({path: this.url}).catch(() => {});
                }, 600);
            } else if (newVal) {
                setTimeout(() => {
                    window.scrollTo(0, window.scrollY - 2);
                    this.reachEndTriggerOnce = true;
                }, 700);
            }
        }
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
.helper {
    position: relative;
    width: 100%;
    padding: 80px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.6s ease;

    &.show {
        opacity: 1;
    }

    &__text {
        color: white;
        font-weight: 500;
        padding-top: 10px;
        text-transform: uppercase;
    }

    &__arrow {
        svg {
            fill: white;
            transform: rotate(90deg);
            width: 20px;
            height: auto;
        }
    }

    &.black {
        .helper {
            &__text {
                color: black;
            }

            &__arrow {
                svg {
                    fill: black;
                }
            }
        }
    }
}
</style>
